import React, { Suspense, lazy } from 'react';
import { ReactComponent as CookieLogo } from '../../assets/cookie_logo.svg';
import { Grid } from '@material-ui/core';
import './SkyCookiesConsent.scss';
const CookieConsent = lazy (() => import("react-cookie-consent"));

export const SkyCookiesConsent = () => {

    return (
        <Suspense fallback={<div />}>
         <CookieConsent
            cookieName="newskywatchcookieconset"
            containerClasses="cookiecontainer"
            buttonWrapperClasses='cookiebtn-container'
            buttonText="Got it!"
            buttonClasses="cookiebtn"
            location="bottom">
                <Grid container alignItems='center' wrap='nowrap'>
                    <Grid item>
                        <CookieLogo />
                    </Grid>
                    <Grid item >
                        <div className="text-small black margin-left-12 cookie-text">We use cookies to enhance experience. By continuing 
                            to visit this site I agree to our use of cookies. <a className="black" href="https://www.skywatch.ai/terms-conditions" rel="noopener noreferrer" target="_blank">More info</a></div>
                    </Grid>
                </Grid>
        </CookieConsent>
    </Suspense>)
}